import React, { Component } from 'react';
import stickybits from 'stickybits';

interface StickyProps {
  offset: number;
  useStickyClasses: boolean;
  zIndex: number;
  style: any;
}

class Sticky extends Component<StickyProps> {
  stickyInstance: any;

  sticky: any;

  static defaultProps = {
    zIndex: 5,
    offset: 0,
    useStickyClasses: true,
    style: {},
  };

  register = (node: any) => {
    if (this.stickyInstance) {
      return;
    }

    const { offset, useStickyClasses } = this.props;

    this.sticky = node;
    this.stickyInstance = stickybits(node, {
      stickyBitStickyOffset: offset,
      useStickyClasses,
    });
  };

  componentDidUpdate() {
    this.stickyInstance.update();
  }

  componentWillUnmount() {
    this.stickyInstance.cleanup();
  }

  render() {
    return (
      <div ref={this.register} style={{ zIndex: this.props.zIndex, ...this.props.style }}>
        {this.props.children}
      </div>
    );
  }
}

export default Sticky;
